import { computeMd5FromFile } from "./hash-core";
import { hashViaWorker } from "./hash-worker-client";

/**
 * ETag (MD5) of an upload, used to verify integrity against the S3/MinIO
 * response ETag. Runs in a Web Worker to keep the main thread responsive;
 * falls back to inline hashing when a Worker is unavailable (old browser or
 * in-app WebView). Output is byte-identical to the previous implementation.
 */
async function computeETag(file: File): Promise<string> {
  try {
    return await hashViaWorker(file);
  } catch {
    return computeMd5FromFile(file);
  }
}

export { computeETag };
